import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';
import { setRef } from '@fullcalendar/core/internal';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);

	const document_type = useRef(null);
	const retention_time = useRef(null);
	const storage_type = useRef(null);
	const strategy_type = useRef(null);

	const importance_list = useRef(null);
	const urgency_list = useRef(null);
	const classification_aposta_list = useRef(null)
	const probabilidade_list = useRef(null);
	const impacto_list = useRef(null);
	const classification_risco_list = useRef(null)

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const [files_image, set_files_image] = useState([]);
	const [, set_image_base64] = useState([])

	const [img_loader, set_img_loader] = useState([])

	const [treeDataPDF, setTreeDataPDF] = useState([])	
	const [treeDataEditable, setTreeDataEditable] = useState([])	
	
	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);
	
	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [document_state_list, set_document_state_list] = useState([])

	const [document_state_edit, set_document_state_edit] = useState(false)
	const [document_state_aprove, set_document_state_aprove] = useState(false)
	const [document_state_remove, set_document_state_remove] = useState(false)

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
		}

		return result

	}

	const fetch_quality_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}/active`)
		let result = []
		if (res.data !== undefined) {
			if(type === 'strategy_classification_aposta' || type === 'strategy_classification_risco') {
				result = res.data
			}
			else {
				for await (let el of res.data) {

					let aux = {
						id: el.id,
						name: translate(el.info.title, 'pt')
					}

					result.push(aux)
				}
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))
		
		set_dados(entities_list.current = [])
		set_dados(document_type.current = [])
		set_dados(retention_time.current = [])
		set_dados(storage_type.current = [])
		set_dados(strategy_type.current = [])

		set_dados(importance_list.current = [])
		set_dados(urgency_list.current = [])
		set_dados(classification_aposta_list.current = [])
		set_dados(classification_risco_list.current = [])

		let aux_document_state = [
			{
				id: 0,
				label: 'Em edição'
			},
			{
				id: 1,
				label: 'Aguarda aprovação'
			},
			{
				id: 2,
				label: 'Em revisão'
			},
			{
				id: 3,
				label: 'Aprovado'
			},
			{
				id: 4,
				label: 'Obsoleto'
			},
			{
				id: 5,
				label: 'Eliminado'
			}
		]
		set_document_state_list(aux_document_state)


		const get_attr = async () => {

			let res_1 = await fetch_quality_attributes('doc_type')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(document_type.current = res_aux_1)
			}
			let res_2 = await fetch_quality_attributes('retention_time')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(retention_time.current = res_aux_2)
			}
			let res_3 = await fetch_quality_attributes('storage_type')
			if (res_3.length > 0) {
				res_3 = order_array(res_3)

				let res_aux_3 = []
				for await (let el of res_3) {
					res_aux_3.push({
						id: el.id,
						label: el.name
					})
				}
				set_dados(storage_type.current = res_aux_3)
			}
			let res_4 = await fetch_entities_list()
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}
			let res_5 = await fetch_quality_attributes('strategy_type')
			if (res_5.length > 0) {
				res_5 = order_array(res_5)

				let res_aux_5 = []
				for await (let el of res_5) {
					res_aux_5.push({
						id: el.id,
						label: el.name
					})
				}
				set_dados(strategy_type.current = res_aux_5)
			}
			let res_6 = await fetch_quality_attributes('strategy_importance')
			if (res_6.length > 0) {
				res_6 = order_array(res_6)

				let res_aux_6 = []
				for await (let el of res_6) {
					res_aux_6.push({
						id: el.id,
						label: el.name
					})
				}
				set_dados(importance_list.current = res_aux_6)
			}
			let res_7 = await fetch_quality_attributes('strategy_urgency')
			if (res_7.length > 0) {
				res_7 = order_array(res_7)

				let res_aux_7 = []
				for await (let el of res_7) {
					res_aux_7.push({
						id: el.id,
						label: el.name
					})
				}
				set_dados(urgency_list.current = res_aux_7)
			}
			let res_8 = await fetch_quality_attributes('strategy_classification_aposta')
			if (res_8.length > 0) {
				// res_8 = order_array(res_8)

				// let res_aux_8 = []
				// for await (let el of res_8) {
				// 	res_aux_8.push({
				// 		id: el.id,
				// 		label: el.name
				// 	})
				// }
				set_dados(classification_aposta_list.current = res_8[0])
			}
			let res_9 = await fetch_quality_attributes('strategy_classification_risco')
			if (res_9.length > 0) {
				// res_9 = order_array(res_9)

				// let res_aux_9 = []
				// for await (let el of res_9) {
				// 	res_aux_9.push({
				// 		id: el.id,
				// 		label: el.name
				// 	})
				// }
				set_dados(classification_risco_list.current = res_9[0])
			}

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {
			
			try {

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
				set_dados(dados.current = res.data[0]);

				if(Array.isArray(res.data) && res.data.length > 0) {
					if(res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					} 
					if(res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					} 
				} 

				set_is_edit(true)

				get_attr()
				
			} catch (error) {
				console.error("Erro:", error);
			}
		}
		try {
			let test = props.location.state.operation;
		
			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				get_attr()
			}

		} catch {
			clean_data()

			get_attr()

			return
		}

	}, [props]);

	const handleSubmit = async e => {
		e.preventDefault();

		console.log('DADOS CURRENT', dados.current)



		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then(async (result) => {
				if (result.isConfirmed) {
					if(document_state_aprove) {
						dados.current.info.settings.document_state = "3"

						dados.current.info.responsable.aproval.execution = today
						dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
					}

					if(notify_responsable_edit) {
						if(dados.current.info.responsable.edit.id !== '') {
							let aux_id = dados.current.info.responsable.edit.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.edit.notification = today
							dados.current.info.responsable.edit.execution = today

							if(dados.current.info.historic === undefined || dados.current.info.historic === null) {
								dados.current.info.historic = []
							}

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
								dados.current.info.historic.push({
									edit: {
										id: aux_responsable[0].id,
										name: aux_responsable[0].label,
										date: today
									},
									aproval: {
										id: '',
										name: '',
										date: ''
									}
								})

								dados.current.info.responsable.aproval.id = ''
								dados.current.info.responsable.aproval.name = ''
								dados.current.info.responsable.aproval.notification = ''
								dados.current.info.responsable.aproval.execution = ''
							}
							else {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								if(aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
								}
								else {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})
									
									dados.current.info.settings.document_state = "1"

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								} 
							}
						}
					}

					if(notify_responsable_aproval) {
						if(dados.current.info.responsable.aproval.id !== '') {
							let aux_id = dados.current.info.responsable.aproval.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.aproval.notification = today

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

							}
						}
					}

					if(notify_responsable_remove) {
						if(dados.current.info.responsable.remove.id !== '') {

							dados.current.info.responsable.remove.notification = today
							dados.current.info.responsable.remove.execution = today

						}

					}

					for await (let el_doc of files_doc_pdf) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_pdf([])
					set_files_doc_pdf_name([])

					for await (let el_doc of files_doc_editable) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_editable([])
					set_files_doc_editable_name([])




					console.log('222 DADOS CURRENT', dados.current)

					await reqPUT(api_crud_route, dados.current)
						.then(async () => { 




							console.log('3333 DADOS CURRENT', dados.current)

							if(notify_responsable_edit) {

							}
							if(notify_responsable_aproval) {
								if(dados.current.info.responsable.aproval.id !== '') {

									let aux_id = dados.current.info.responsable.aproval.id
									let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

									if(Array.isArray(aux_responsable) && aux_responsable.length > 0) {

										let aux = {
											id: dados.current.id,
											uniqid: dados.current.info.uniqid,
											companycode: dados.current.info.companycode,

											type: 'quality',
											title: translate(dados.current.info.title, lang),
											description: translate(dados.current.info.description, lang),
											responsaveis: [{
												value: aux_responsable[0].id
											}],
											state_object: {
												value: 1,
												labelEn: "Pending approval",
												labelPt: "Pendente de aprovação"
											},
											deadline: '',
										}

										reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

										return

										let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
											'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>' +
														'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
													'</div>' +
												'</td>' + 
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>'+
														'<span>'+ today_aux + '</span>'+
													'</div>'+
												'</td>' +
											'</tr>' +
			
											'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
											'</tr>' +

											'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
													'<div>'+
														'<br/>'+
														'<span>' + language[lang].notification_aproval_text + '</span>'+
														'<br/>'+
													'</div>'+
												'</td>' +
											'</tr>' +
										'</table>'

										// let sendFrom = 'web.dev@assec.pt'
										// let sendTo = ['web.teste@assec.pt']
										// let sendToCC = ['web.dev@assec.pt']
										// let subject = language[lang].notification_aproval_subject
										// let content = mail_content
										// let attachment = []

										// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
									}
								
								}
							}
							if(notify_responsable_remove) {
								if(dados.current.info.responsable.remove.id !== '') {
									// let aux_id = dados.current.info.responsable.remove.id
									// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

									// console.log('remove aux_responsable', aux_responsable)
									dados.current.info.responsable.remove.notification = today
								}
							}

						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} 
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then(async (result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					if(document_state_aprove) {
						dados.current.info.settings.document_state = "3"

						dados.current.info.responsable.aproval.execution = today
						dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
					}

					if(notify_responsable_edit) {
						if(dados.current.info.responsable.edit.id !== '') {
							let aux_id = dados.current.info.responsable.edit.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.edit.notification = today
							dados.current.info.responsable.edit.execution = today

							if(dados.current.info.historic === undefined || dados.current.info.historic === null) {
								dados.current.info.historic = []
							}

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
								dados.current.info.historic.push({
									edit: {
										id: aux_responsable[0].id,
										name: aux_responsable[0].label,
										date: today
									},
									aproval: {
										id: '',
										name: '',
										date: ''
									}
								})

								// dados.current.info.responsable.aproval.id = ''
								// dados.current.info.responsable.aproval.name = ''
								// dados.current.info.responsable.aproval.notification = ''
								// dados.current.info.responsable.aproval.execution = ''
							}
							else {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								if(aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
								}
								else {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})
									
									dados.current.info.settings.document_state = "1"

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								} 
							}
						}
					}

					if(notify_responsable_aproval) {
						if(dados.current.info.responsable.aproval.id !== '') {
							let aux_id = dados.current.info.responsable.aproval.id
							let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

							dados.current.info.responsable.aproval.notification = today

							if(Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
								let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
								dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

							}
						}
					}

					if(notify_responsable_remove) {
						if(dados.current.info.responsable.remove.id !== '') {

							dados.current.info.responsable.remove.notification = today
							dados.current.info.responsable.remove.execution = today

						}

					}

					for await (let el_doc of files_doc_pdf) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_pdf([])
					set_files_doc_pdf_name([])

					for await (let el_doc of files_doc_editable) {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
						}
					}
					set_files_doc_editable([])
					set_files_doc_editable_name([])

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if(name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if(aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if(el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

		
	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if(dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if(name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	
	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {
		
		set_document_state_aprove(!document_state_aprove)

	}

	const change_document_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		console.log('dados.current.info.settings', dados.current.info.settings)

	}

	const change_document_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if(name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if(name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if(name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution:	''
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}
	const change_document_responsable_date = (e) => {
		const { name, value, dataset } = e.target;
		const { type } = dataset

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		set_dados(dados.current.info.responsable[name]['notification'] = value)
		set_dados(dados.current.info.responsable[name][type] = value)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info, )
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order], )
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'quality')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/quality/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if(dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if(!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const add_action = (type) => {
		set_dados(dados.current.info.action.push({
			id: Date.now(),
			strategy_type: type
		}))
	}

	const remove_action = (id) => {


		console.log('id', id)




		let aux = []
		dados.current.info.action.forEach((el) => {
			if(parseInt(el.id) !== parseInt(id)) {
				aux.push(el)
			}
		})

		set_dados(dados.current.info.action = aux)


		console.log('aux', aux)


		setRefresh(r => r + 1)

	}

	const change_action = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset

		console.log('NAME', name)
		console.log('VALUE', value)
		
		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
				el[name] = value
			}
		})

		set_dados(dados.current.info.action, )

		setRefresh(r => r + 1)

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_action_responsable = (e) => {
		const { name, value, dataset } = e.target;
		const { parent, id } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: '',
			name: value,
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.id = aux_entity[0].id
			aux.name = aux_entity[0].label
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
				el[name] = aux
			}
		})

		console.log('dados.current.info.action', dados.current.info.action)


	}	
	
	const change_action_responsable_name = (e) => {
		const { name, value, dataset } = e.target;
		const { parent, id } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: '',
			name: value,
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.name = aux_entity[0].label
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
				el[name] = aux
			}
		})

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_action_responsable_date = (e) => {
		
	}

	const add_action_2 = (id) => {

		dados.current.info.action.forEach((el) => {
			if(parseInt(el.id) === parseInt(id)) {
				if(el['action'] === undefined)
					el['action'] = []

				el['action'].push({
					id: Date.now()
				})
			}
		})

		setRefresh(r => r + 1)
		console.log('-->', dados.current.info.action)
	}

	const remove_action_2 = (id, id_parent) => {

		let aux = []
		dados.current.info.action.forEach((el, el_k) => {
			if(parseInt(el.id) === parseInt(id_parent)) {
				el.action.forEach(el_2 => {
					if(parseInt(el_2.id) !== parseInt(id)) {
						aux.push(el_2)
					}
				})

				set_dados(dados.current.info.action[el_k].action = aux)

				setRefresh(r => r + 1)
			}
		})

	}

	const change_action_2 = (e) => {
		const { name, value, dataset } = e.target;
		const { id, idparent } = dataset
		
		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(idparent)) {
				el.action.forEach(el_2 => {
					if(parseInt(el_2.id) === parseInt(id)) {
						el_2[name] = value
					}
				})
			}
		})

		set_dados(dados.current.info.action, )

		setRefresh(r => r + 1)

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_action_responsable_2 = (e) => {
		const { name, value, dataset } = e.target;
		const { id, idparent } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: '',
			name: value,
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.id = aux_entity[0].id
			aux.name = aux_entity[0].label
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(idparent)) {
				el.action.forEach(el_2 => {
					if(parseInt(el_2.id) === parseInt(id)) {
						if(el_2[name] === undefined || el_2[name] === null) {
							el_2[name] = {}
						}
						el_2[name] = aux
					}
				})
			}
		})

		setRefresh(r => r + 1)
		console.log('dados.current.info.action', dados.current.info.action)

	}	
	
	const change_action_responsable_name_2 = (e) => {
		const { name, value, dataset } = e.target;
		const { id, idparent } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		let today = new Date().toJSON()

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: '',
			name: value,
			notification: today,
			execution:	today
		}
		if(Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.name = aux_entity[0].label
		}

		dados.current.info.action.forEach(el => {
			if(parseInt(el.id) === parseInt(idparent)) {
				el.action.forEach(el_2 => {
					if(parseInt(el_2.id) === parseInt(id)) {
						if(el_2[name] === undefined || el_2[name] === null) {
							el_2[name] = {}
						}
						el_2[name] = aux
					}
				})
			}
		})

		setRefresh(r => r + 1)
		console.log('dados.current.info.action', dados.current.info.action)

	}

	const change_action_responsable_date_2 = (e) => {
		
	}

	return isloading ?
		<Loader />
	:
		isRedirect
	?
		<Redirect to={endpoints.list} replace />
	:
		<main>
			<div className={`dash-cards header`}>
				<div className="container">
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>
			</div>

			<div className={`dash-cards body`}>
				<div className="container">
					<div className="row">	
						<div className="mb-5 mb-xl-10">
							<div className='card'>
								<div className="card-header border-0 d-flex justify-content-sm-between">
									<div className="card-title m-0">
										<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
									</div>
									<div className="card-toolbar">
										<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
											{
												content_language.length > 1 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<li key={k_lang} className="nav-item d-none">
																<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
															</li>
														)
													})
												:
													null
											}
										</ul>
									</div>
								</div>

								<div id="div-content">
									<form id="form" onSubmit={handleSubmit}>
										<div className="card-body border-top p-4">
											<div className='tab-content'>
												{
												content_language.length > 0 ?
													content_language.map((el_lang, k_lang) => {
														return (
															<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">

																<div className='row mb-4 d-none'>
																	<div className="col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_document_type}</label>
																		<select
																			name="doc_type"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_document_settings}
																			value={dados?.current?.info?.settings?.doc_type !== undefined && dados?.current?.info?.settings?.doc_type !== null ? dados.current.info.settings.doc_type : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			document_type.current !== undefined && document_type.current !== null ?
																				document_type.current.map((el_dt, k_dt) => (
																					<option key={k_dt} value={el_dt.id}>
																						{el_dt.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																	<div className="col-4 col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_document_state}</label>
																		<select
																			name="document_state"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_document_settings}
																			value={dados?.current?.info?.settings?.document_state !== undefined && dados?.current?.info?.settings?.document_state !== null ? dados.current.info.settings.document_state : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			document_state_list !== undefined && document_state_list !== null ?
																				document_state_list.map((el_dsl, k_dsl) => (
																					<option key={k_dsl} value={el_dsl.id}>
																						{el_dsl.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																	{
																	dados?.current?.info?.settings?.document_state !== undefined && dados?.current?.info?.settings?.document_state !== null && 
																	parseInt(dados?.current?.info?.settings?.document_state) === 1 && parseInt(dados.current.info.responsable.aproval.id) === parseInt(getTokenInfo().id) ?
																		<div className="col-2"> 
																			<div className="d-flex">
																				{console.log('dados.current.info.settings.document_state', dados.current.info.settings.document_state)}
																				<div className="ms-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-aproval'}
																								name={"aproval"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.settings.document_state !== undefined && parseInt(dados.current.info.settings.document_state) === 3 ? true : false}
																								onChange={handleSingleCheckAproval}
																								defaultChecked={dados.current.info.settings.document_state !== undefined && parseInt(dados.current.info.settings.document_state) === 3 ? true : false}
																							/>
																							<span className="slider" htmlFor={'item-switch-aproval'}></span>
																						</label>
																					</div>
																				</div>
																			</div>
																		</div>
																	:
																		null
																	}
																</div>

																<div className='row mb-4'>
																	<div className="col-2">
																		<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_tag}</label>
																		<input type="text" name="tag" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.tag} onChange={(e) => handle_change_info(e)} className="form-control rounded-0" />
																	</div>
																	<div className="col-5">
																		<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_name} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																		<input type="text" name="title" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.title, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" required={el_lang.id === '1' ? 'required' : ''} />
																	</div>
																	<div className="col-2 d-none">
																		<label className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>{language[lang].field_version}</label>
																		<input type="text" name="version" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.version} onChange={(e) => handle_change_info(e)} className="form-control rounded-0" />
																	</div>
																	<div className="col-4 col-md-3">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].date_aprovation}</label>
																		<input
																			type="date"
																			name="date_aprovation"
																			data-langid={el_lang.id}
																			data-lang={el_lang.code}
																			defaultValue={dados.current.info.date_aprovation}
																			onChange={(e) => handle_change_info(e)}
																			className="form-control rounded-0" />
																	</div>
																	{
																	el_lang.id === '1' || true ?
																		<div className="col-2"> 
																			<div className="d-flex">
																				<div className="mb-3 d-none">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-active'}
																								name={"active"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.active}
																								onChange={handleSingleCheckActive}
																								defaultChecked={dados.current.info.active}
																							/>
																							<span className="slider" htmlFor={'item-switch-active'}></span>
																						</label>
																					</div>
																				</div>

																				<div className="ms-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_avaiable}</label>
																					<div className="input-group">
																						<label className="switch">
																							<input
																								id={'item-switch-avaiable'}
																								name={"avaiable"}
																								className=""
																								type="checkbox"
																								value={dados.current.info.avaiable}
																								onChange={handleSingleCheckAvaiable}
																								defaultChecked={dados.current.info.avaiable}
																							/>
																							<span className="slider" htmlFor={'item-switch-avaiable'}></span>
																						</label>
																					</div>
																				</div>
																				
																			</div>
																		</div>
																	:
																		null
																	}
																</div>

																<div className="row mb-4">
																	<div className="col-6">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																		<textarea type="text" rows="4" name="description" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.description, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																	</div>
																</div>
																
																<div className='row mb-4 d-none'>
																	<div className="col-4 col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_storage_type}</label>
																		<select
																			name="storage_type"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_document_settings}
																			value={dados?.current?.info?.settings?.storage_type !== undefined && dados?.current?.info?.settings?.storage_type !== null ? dados.current.info.settings.storage_type : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			storage_type.current !== undefined && storage_type.current !== null ?
																				storage_type.current.map((el_st, k_st) => (
																					<option key={k_st} value={el_st.id}>
																						{el_st.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>
																	<div className="col-4 col-md-4">
																		<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_storage_local}</label>
																		<input type="text" name="storage_local" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={dados.current.info.settings.storage_local} onChange={(e) => change_document_settings(e)} className="form-control rounded-0" />
																	</div>
																	<div className="col-4 col-md-4">
																		<label className="fs-6 fw-bold mb-2">{language[lang].field_retention_time}</label>
																		<select
																			name="retention_time"
																			className="form-select form-control mb-4 mb-lg-0 rounded-0"
																			onChange={change_document_settings}
																			value={dados?.current?.info?.settings?.retention_time !== undefined && dados?.current?.info?.settings?.retention_time !== null ? dados.current.info.settings.retention_time : ''}
																		>
																			<option value="">{language[lang].field_choose}</option>
																			{
																			retention_time.current !== undefined && retention_time.current !== null ?
																				retention_time.current.map((el_rt, k_rt) => (
																					<option key={k_rt} value={el_rt.id}>
																						{el_rt.label}
																					</option>
																				))
																			:
																				null
																			}
																		</select>
																	</div>

																	
																</div>
																
																<div className="row mb-4">
																	<div className="col-12 col-md-6">
																		<div className="div-doc">
																			<label className="col-form-label fw-bold fs-6">{language[lang].editable_documents}</label>

																			<div className="dropzone-panel mb-lg-0 mb-2">
																				<div className="div-form-input col-12 custom-file">
																					<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-editable-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																					<input
																						id={"input-files-editable-" + 0 + '-' + el_lang.id}
																						type="file"
																						// accept="application/pdf"
																						data-order={0}
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						data-type={'doc'}
																						className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																						onChange={onChangeHandlerFilesEditable}
																						multiple
																					/>
																				</div>
																			</div>

																			<div className="row">
																				{
																					treeDataEditable[0] !== undefined && treeDataEditable[0][el_lang.id] !== undefined ?
																						<SortableTree
																							isVirtualized={false}
																							treeData={treeDataEditable[0][el_lang.id]}
																							maxDepth={1}
																							canDrag={false}
																							//onChange={() => console.log('onChange')}
																							onChange={treeDataEditable => handle_change_tree_editable(treeDataEditable, 0, el_lang.id)}
																							getNodeKey={({ node }) => node.id}
																							generateNodeProps={extendedNode => ({
																								title: (
																									<>
																										{extendedNode.node.title}
																										<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_editable} />
																									</>
																								),
																								buttons: [
																									<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																									<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																									<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																									<button type="button" onClick={() => remove_element_tree_editable(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																								],
																							})}
																						/>
																						:
																						''
																				}
																			</div>
																		</div>
																	</div>
																	<div className="col-12 col-md-6">
																		<div className="div-doc">
																			<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																			<div className="dropzone-panel mb-lg-0 mb-2">
																				<div className="div-form-input col-12 custom-file">
																					<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + 0 + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																					<input
																						id={"input-files-pdf-" + 0 + '-' + el_lang.id}
																						type="file"
																						accept="application/pdf"
																						data-order={0}
																						data-langid={el_lang.id}
																						data-lang={el_lang.code}
																						data-type={'doc'}
																						className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																						onChange={onChangeHandlerFilesPDF}
																						multiple
																					/>
																				</div>
																			</div>

																			<div className="row">
																				{
																					treeDataPDF[0] !== undefined && treeDataPDF[0][el_lang.id] !== undefined ?
																						<SortableTree
																							isVirtualized={false}
																							treeData={treeDataPDF[0][el_lang.id]}
																							maxDepth={1}
																							canDrag={false}
																							//onChange={() => console.log('onChange')}
																							onChange={treeDataPDF => handle_change_tree_pdf(treeDataPDF, 0, el_lang.id)}
																							getNodeKey={({ node }) => node.id}
																							generateNodeProps={extendedNode => ({
																								title: (
																									<>
																										<span>{extendedNode.node.title}</span>
																										<input type="text" className="form-control form-control-sm rounded-0 d-none" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree_pdf} />
																									</>
																								),
																								buttons: [
																									<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																									<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																									<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																									<button type="button" onClick={() => remove_element_tree_pdf(0, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																								],
																							})}
																						/>
																						:
																						''
																				}
																			</div>
																		</div>
																	</div>
																</div>
																
															</div>
														)
													})
												:
													null
												}
											</div>
										</div>

										<div className="card-body border-top p-4 d-none">

											<div className="row mb-4">														
												<div className="col-12 col-md-4">
													<label className="fs-6 fw-bold mb-2">{language[lang].field_edit_responsable}</label>
													<select
														name="edit"
														className="form-select form-control mb-2 rounded-0"
														onChange={change_document_responsable}
														value={dados?.current?.info?.responsable?.edit?.id !== undefined && dados?.current?.info?.responsable?.edit?.id !== null ? dados.current.info.responsable.edit?.id : ''}
													>
														<option value="">{language[lang].field_choose_respnsable}</option>
														{
														entities_list.current !== undefined && entities_list.current !== null ?
															entities_list.current.map((el_el, k_el) => (
																<option key={k_el} value={el_el.id}>
																	{el_el.label}
																</option>
															))
														:
															null
														}
													</select>
													<input
														type="date"
														name="edit"
														data-type="execution"
														defaultValue={
															dados?.current?.info?.responsable?.edit?.execution !== undefined && dados?.current?.info?.responsable?.edit?.execution !== null && dados.current.info.responsable.edit.execution !== '' ? 
																dados.current.info?.responsable.edit.execution.split('T')[0]
															: 
																''
															}
														onChange={(e) => change_document_responsable_date(e)}
														className="form-control rounded-0" 
													/>
												</div>
												<div className="col-12 col-md-4">
													<label className="fs-6 fw-bold mb-2">{language[lang].field_aproval_responsable}</label>
													<select
														name="aproval"
														className="form-select form-control mb-2 rounded-0"
														onChange={change_document_responsable}
														value={dados?.current?.info?.responsable?.aproval?.id !== undefined && dados?.current?.info?.responsable?.aproval?.id !== null ? dados.current.info.responsable.aproval?.id : ''}
													>
														<option value="">{language[lang].field_choose_respnsable}</option>
														{
														entities_list.current !== undefined && entities_list.current !== null ?
															entities_list.current.map((el_el, k_el) => (
																<option key={k_el} value={el_el.id}>
																	{el_el.label}
																</option>
															))
														:
															null
														}
													</select>
													<input
														type="date"
														name="aproval"
														data-type="execution"
														defaultValue={
															dados?.current?.info?.responsable?.aproval?.execution !== undefined && dados?.current?.info?.responsable?.aproval?.execution !== null && dados.current.info.responsable.aproval.execution !== '' ? 
																dados.current.info?.responsable.aproval.execution.split('T')[0]
															: 
																''
															}
														onChange={(e) => change_document_responsable_date(e)}
														className="form-control rounded-0" 
													/>
												</div>
												<div className="col-12 col-md-4">
													<label className="fs-6 fw-bold mb-2">{language[lang].field_remove_responsable}</label>
													<select
														name="remove"
														className="form-select form-control mb-2 rounded-0"
														onChange={change_document_responsable}
														value={dados?.current?.info?.responsable?.remove?.id !== undefined && dados?.current?.info?.responsable?.remove?.id !== null ? dados.current.info.responsable.remove?.id : ''}
													>
														<option value="">{language[lang].field_choose_respnsable}</option>
														{
														entities_list.current !== undefined && entities_list.current !== null ?
															entities_list.current.map((el_el, k_el) => (
																<option key={k_el} value={el_el.id}>
																	{el_el.label}
																</option>
															))
														:
															null
														}
													</select>
													<input
														type="date"
														name="remove"
														data-type="execution"
														defaultValue={
															dados?.current?.info?.responsable?.remove?.execution !== undefined && dados?.current?.info?.responsable?.remove?.execution !== null && dados.current.info.responsable.remove.execution !== '' ? 
																dados.current.info?.responsable.remove.execution.split('T')[0]
															: 
																''
															}
														onChange={(e) => change_document_responsable_date(e)}
														className="form-control rounded-0" 
													/>
												</div>
											</div>

										</div>

										<div className="card-body border-top p-4">
											<div className='row mb-4'>
												<div className='col-12 text-end'>
													<button type="button" className='btn btn-sm btn-secondary rounded-0 me-2' onClick={() => add_action(37)}>{language[lang].add_aposta}</button>
													<button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={() => add_action(38)}>{language[lang].add_risco}</button>
												</div>
											</div>

											{
											Array.isArray(dados.current.info.action) && dados.current.info.action.filter(e => parseInt(e.strategy_type) === 37).length > 0 ?
												<div className='row mb-4'>	
													<h3 className='fw-bolder m-3'>{language[lang].apostas}</h3>		
													<div className="accordion border-0" id="accordionActionsApostas">
														{
														dados.current.info.action.filter(e => parseInt(e.strategy_type) === 37).map((a_el, a_key) => {
															if(a_el?.strategy_type === undefined || a_el?.strategy_type === null || a_el.strategy_type === '' || parseInt(a_el.strategy_type) === 37) {
																return (
																	<div key={a_key} className="accordion-item border-0 border-bottom">
																		<h2 className="accordion-header">
																			<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_" + a_key} aria-expanded="true" aria-controls={"collapse_" + a_key}>
																				{ a_el?.number !== undefined ? 'APOSTA ' + a_el.number : 'APOSTA ' + (a_key + 1) } { a_el?.description !== undefined ? ' - ' + a_el.description : '' }
																			</button>
																		</h2>
																		<div id={"collapse_" + a_key} className="accordion-collapse collapse p-3" data-bs-parent="#accordionActionsApostas">
																			<div className='row mb-4'>
																				<div className="col-12 text-end">
																					<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remove_action(a_el.id)}><i className="bi bi-x-lg"></i></button>
																				</div>
																				<div className="col-md-4 d-none">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_action_choose}</label>
																					<select
																						name="strategy_type"
																						data-parent={'action'}
																						data-ir={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.strategy_type !== undefined && a_el?.strategy_type !== null ? a_el?.strategy_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						strategy_type.current !== undefined && strategy_type.current !== null ?
																							strategy_type.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3 d-none">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].number_aposta}</label>
																					<input type="text" name="number" data-parent={'action'} data-id={a_el.id} value={a_el?.number} onChange={(e) => change_action(e)} className="form-control rounded-0 text-end" />
																				</div>																				
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_importance}</label>
																					<select
																						name="importance_type"
																						data-parent={'action'}
																						data-id={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.importance_type !== undefined && a_el?.importance_type !== null ? a_el.importance_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						importance_list.current !== undefined && importance_list.current !== null ?
																							importance_list.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_urgency}</label>
																					<select
																						name="urgency_type"
																						data-parent={'action'}
																						data-id={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.urgency_type !== undefined && a_el?.urgency_type !== null ? a_el.urgency_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						urgency_list.current !== undefined && urgency_list.current !== null ?
																							urgency_list.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_classification}</label>
																					<br />
																					{
																					a_el.importance_type !== undefined && a_el.importance_type !== null && a_el.importance_type !== '' &&
																					a_el.urgency_type !== undefined && a_el.urgency_type !== null && a_el.urgency_type !== '' ?
																						<p className='p-2 mb-2 bg-primary text-white text-center'>																						
																							{classification_aposta_list.current.info.values.filter(e => parseInt(e.i) === parseInt(a_el.importance_type) && parseInt(e.u) === parseInt(a_el.urgency_type)).length > 0 ? classification_aposta_list.current.info.values.filter((e) => parseInt(e.i) === parseInt(a_el.importance_type) && parseInt(e.u) === parseInt(a_el.urgency_type))[0].tag : '' }
																						</p>
																					:
																						null
																					}
																				</div>
																				<div className="col-4 col-md-3">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].date_identification}</label>
																					<input
																						type="date"
																						name="date_identification"
																						data-parent={'action'}
																						data-id={a_el.id}
																						defaultValue={a_el?.date_identification !== undefined && a_el?.date_identification !== null ? a_el.date_identification : ''}
																						onChange={(e) => change_action(e)}
																						className="form-control rounded-0" />
																				</div>

																				<div className="col-12 mt-3">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description}</label>
																					<textarea type="text" rows="4" name="description" data-parent={'action'} data-id={a_el.id} value={a_el?.description} onChange={(e) => change_action(e)} className="form-control rounded-0" />
																				</div>
																				
																				<div className='col-12 text-end'>
																					<button type="button" className='btn btn-sm btn-secondary rounded-0 mt-4' onClick={() => add_action_2(a_el.id)}>{language[lang].add_action}</button>
																				</div>
																			</div>

																			{
																			a_el.action !== undefined && a_el.action !== null ?
																				a_el.action.map((el_2, k_e) => {
																					return (
																						<div key={k_e} className={'row mb-4 py-3' + (k_e % 2 !== 0 ? ' bg-light' : '')}>

																							<div className="col-3 col-md-1">
																								<label className={"fs-6 fw-bold mb-2"}>{language[lang].number_action}</label>
																								<input type="text" name="number" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.number} onChange={(e) => change_action_2(e)} className="form-control rounded-0 text-end" />
																							</div>	

																							<div className="col-4 col-md-3 d-none">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																								<input type="text" name="responsable" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.responsable?.name !== undefined && el_2?.responsable?.name !== null ? el_2.responsable.name : ''} onChange={(e) => change_action_responsable_name_2(e)} className="form-control rounded-0" />
																							</div>
																							<div className="col-4 col-md-3">
																								<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																								<select
																									name="responsable"
																									data-parent={'action'} 
																									data-id={el_2.id} 
																									data-idparent={a_el.id}
																									data-type="identification"
																									className="form-select form-control mb-4 mb-lg-0 rounded-0"
																									onChange={change_action_responsable_2}
																									value={el_2?.responsable?.id !== undefined && el_2?.responsable?.id !== null ? el_2?.responsable.id : ''}
																								>
																									<option value="">{language[lang].field_choose_responsable}</option>
																									{
																									entities_list.current !== undefined && entities_list.current !== null ?
																										entities_list.current.map((el_el, k_el) => (
																											<option key={k_el} value={el_el.id}>
																												{el_el.label}
																											</option>
																										))
																									:
																										null
																									}
																								</select>
																							</div>
																							<div className="col-5 col-md-8 text-end">
																								<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remove_action_2(el_2.id, a_el.id)}><i className="bi bi-x-lg"></i></button>
																							</div>

																							<div className='col-12'></div>

																							<div className="col-6">
																								<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_description}</label>
																								<textarea type="text" rows="4" name="description" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.description} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																							</div>

																							<div className='col-6'>

																								<div className='row mb-3 d-none'>
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_indicator}</label>
																										<input type="text" name="indicator" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.indicator} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_goal}</label>
																										<input type="text" name="goal" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.goal} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								</div>

																								<div className='row mb-3'>																								
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_goal_initial}</label>
																										<input type="text" name="goal_initial" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.goal_initial} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_deadline_initial}</label>
																										<input type="date" name="deadline_initial" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.deadline_initial} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								</div>

																								<div className='row mb-3'>
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_goal_actual}</label>
																										<input type="text" name="goal_actual" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.goal_actual} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_deadline_actual}</label>
																										<input type="date" name="deadline_actual" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.deadline_actual} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								</div>
																							</div>
																						</div>
																					)
																				})
																			:
																				null
																			}
																		</div>
																	</div>
																)
															}
															else {
																return null
															}
														})
														}
													</div>
												</div>
											:
												null
											}

											{
											Array.isArray(dados.current.info.action) && dados.current.info.action.filter(e => parseInt(e.strategy_type) === 38).length > 0 ?
												<div className='row mb-4'>	
													<h3 className='fw-bolder m-3'>{language[lang].riscos}</h3>		
													<div className="accordion border-0" id="accordionActionsRiscos">
														{
														dados.current.info.action.filter(e => parseInt(e.strategy_type) === 38).map((a_el, a_key) => {
															if(a_el?.strategy_type === undefined || a_el?.strategy_type === null || a_el.strategy_type === '' || parseInt(a_el.strategy_type) === 38) {
																return (
																	<div key={a_key} className="accordion-item border-0 border-bottom">
																		<h2 className="accordion-header">
																			<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse_r_" + a_key} aria-expanded="true" aria-controls={"collapse_r_" + a_key}>
																				{ a_el?.number !== undefined ? 'RISCO ' + a_el.number : 'RISCO ' + (a_key + 1) } { a_el?.description !== undefined ? ' - ' + a_el.description : '' }
																			</button>
																		</h2>
																		<div id={"collapse_r_" + a_key} className="accordion-collapse collapse p-3" data-bs-parent="#accordionActionsRiscos">
																			<div className='row mb-4'>
																				<div className="col-12 text-end">
																					<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remove_action(a_el.id)}><i className="bi bi-x-lg"></i></button>
																				</div>
																				<div className="col-md-4 d-none">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_action_choose}</label>
																					<select
																						name="strategy_type"
																						data-parent={'action'}
																						data-ir={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.strategy_type !== undefined && a_el?.strategy_type !== null ? a_el?.strategy_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						strategy_type.current !== undefined && strategy_type.current !== null ?
																							strategy_type.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3 d-none">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].number_risco}</label>
																					<input type="text" name="number" data-parent={'action'} data-id={a_el.id} value={a_el?.number} onChange={(e) => change_action(e)} className="form-control rounded-0" />
																				</div>																				
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_probabilidade}</label>
																					<select
																						name="probability_type"
																						data-parent={'action'}
																						data-id={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.probability_type !== undefined && a_el?.probability_type !== null ? a_el.probability_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						importance_list.current !== undefined && importance_list.current !== null ?
																							importance_list.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_impacto}</label>
																					<select
																						name="impact_type"
																						data-parent={'action'}
																						data-id={a_el.id}
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						onChange={change_action}
																						value={a_el?.impact_type !== undefined && a_el?.impact_type !== null ? a_el.impact_type : ''}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{
																						urgency_list.current !== undefined && urgency_list.current !== null ?
																							urgency_list.current.map((el_dt, k_dt) => (
																								<option key={k_dt} value={el_dt.id}>
																									{el_dt.label}
																								</option>
																							))
																						:
																							null
																						}
																					</select>
																				</div>
																				<div className="col-4 col-md-3">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_classification}</label>
																					<br />
																					{
																					a_el.probability_type !== undefined && a_el.probability_type !== null && a_el.probability_type !== '' &&
																					a_el.impact_type !== undefined && a_el.impact_type !== null && a_el.impact_type !== '' ?
																						<p className='p-2 mb-2 bg-primary text-white text-center'>																						
																							{classification_risco_list.current.info.values.filter(e => parseInt(e.i) === parseInt(a_el.probability_type) && parseInt(e.u) === parseInt(a_el.impact_type)).length > 0 ? classification_risco_list.current.info.values.filter((e) => parseInt(e.i) === parseInt(a_el.probability_type) && parseInt(e.u) === parseInt(a_el.impact_type))[0].tag : '' }
																						</p>
																					:
																						null
																					}
																				</div>
																				<div className="col-4 col-md-3">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].date_identification}</label>
																					<input
																						type="date"
																						name="date_identification"
																						data-parent={'action'}
																						data-id={a_el.id}
																						defaultValue={a_el?.date_identification !== undefined && a_el?.date_identification !== null ? a_el.date_identification : ''}
																						onChange={(e) => change_action(e)}
																						className="form-control rounded-0" />
																				</div>
																				<div className="col-12 mt-3">
																					<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description}</label>
																					<textarea type="text" rows="4" name="description" data-parent={'action'} data-id={a_el.id} value={a_el?.description} onChange={(e) => change_action(e)} className="form-control rounded-0" />
																				</div>
																				
																				<div className='col-12 text-end'>
																					<button type="button" className='btn btn-sm btn-secondary rounded-0 mt-4' onClick={() => add_action_2(a_el.id)}>{language[lang].add_action}</button>
																				</div>
																			</div>

																			{
																			a_el.action !== undefined && a_el.action !== null ?
																				a_el.action.map((el_2, k_e) => {
																					return (
																						<div key={k_e} className={'row mb-4 py-3' + (k_e % 2 !== 0 ? ' bg-light' : '')}>

																							<div className="col-3 col-md-1">
																								<label className={"fs-6 fw-bold mb-2"}>{language[lang].number_action}</label>
																								<input type="text" name="number" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.number} onChange={(e) => change_action_2(e)} className="form-control rounded-0 texst-end" />
																							</div>	
																							<div className="col-9 col-md-11 text-end">
																								<button type="button" className="btn btn-sm btn-danger rounded-0" onClick={() => remove_action_2(el_2.id, a_el.id)}><i className="bi bi-x-lg"></i></button>
																							</div>

																							<div className='col-12'></div>

																							<div className="col-6">
																								<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_description}</label>
																								<textarea type="text" rows="4" name="description" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.description} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																							</div>

																							<div className='col-6'>
																								<div className='row mb-3'>

																									<div className="col-12 col-md-6 d-none">
																										<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																										<input type="text" name="responsable" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.responsable?.name !== undefined && el_2?.responsable?.name !== null ? el_2.responsable.name : ''} onChange={(e) => change_action_responsable_name_2(e)} className="form-control rounded-0 text-end" />
																									</div>
																									<div className="col-12 col-md-6">
																										<label className="fs-6 fw-bold mb-2">{language[lang].field_responsable}</label>
																										<select
																											name="responsable"
																											data-parent={'action'} 
																											data-id={el_2.id} 
																											data-idparent={a_el.id}
																											data-type="identification"
																											className="form-select form-control mb-4 mb-lg-0 rounded-0"
																											onChange={change_action_responsable_2}
																											value={el_2?.responsable?.id !== undefined && el_2?.responsable?.id !== null ? el_2?.responsable.id : ''}
																										>
																											<option value="">{language[lang].field_choose_responsable}</option>
																											{
																											entities_list.current !== undefined && entities_list.current !== null ?
																												entities_list.current.map((el_el, k_el) => (
																													<option key={k_el} value={el_el.id}>
																														{el_el.label}
																													</option>
																												))
																											:
																												null
																											}
																										</select>
																									</div>
																								</div>

																								<div className='row mb-3'>
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_indicator}</label>
																										<input type="text" name="indicator" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.indicator} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								
																									<div className="col-6">
																										<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_action_goal}</label>
																										<input type="text" name="goal" data-parent={'action'} data-id={el_2.id} data-idparent={a_el.id} value={el_2?.goal} onChange={(e) => change_action_2(e)} className="form-control rounded-0" />
																									</div>
																								</div>
																							</div>
																						</div>
																					)
																				})
																			:
																				null
																			}
																		</div>
																	</div>
																)
															}
															else {
																return null
															}
														})
														}
													</div>
												</div>
											:
												null
											}
										</div>

									</form>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>

			<div className={'dash-cards footer'}>
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							<li className="nav-item">
								<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
								</Link>
							</li>
							<li className={"nav-item " + show_delete_button}>
								<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
									<i className="bi bi-trash3 me-2"></i>
									<span>{language[lang].delete}</span>
								</button>
							</li>
							<li className="nav-item">
								<button type="submit" form="form" className="nav-link">
									<i className="bi bi-floppy me-2"></i>
									<span>{language[lang].save}</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</main>
}
